import { useEffect, useState } from 'react'
import { Modal } from '@/common/ui/Modal'
import { Button } from '@/common/ui/Form/Button'
import { cn } from '@/common/lib/cn/cn'
import {
    INSUFFICIENT_BALANCE_MODAL_ID,
    listenInsufficientBalanceModalOpen,
    closeInsufficientBalanceModal,
    type InsufficientBalanceStep,
} from '../model'
import { TopUpForm } from './TopUpForm'

export const InsufficientBalanceModal = () => {
    const [step, setStep] = useState<InsufficientBalanceStep>(1)

    const handleOpen = (nextStep?: InsufficientBalanceStep) => {
        const modalCheckbox = document.getElementById(INSUFFICIENT_BALANCE_MODAL_ID) as HTMLInputElement | null
        if (modalCheckbox) {
            modalCheckbox.checked = true
        }
        setStep(nextStep || 1)
    }

    const handleClose = () => {
        closeInsufficientBalanceModal()
        setStep(1)
    }

    const handleStepChange = (nextStep: InsufficientBalanceStep) => {
        setStep(nextStep)
    }

    useEffect(() => {
        const unsubscribe = listenInsufficientBalanceModalOpen(({ step: nextStep }) => {
            handleOpen(nextStep)
        })
        return () => {
            unsubscribe?.()
        }
    }, [])

    useEffect(() => {
        const checkbox = document.getElementById(INSUFFICIENT_BALANCE_MODAL_ID) as HTMLInputElement | null
        if (!checkbox) return

        const handleChange = () => {
            if (!checkbox.checked) {
                setStep(1)
            }
        }

        checkbox.addEventListener('change', handleChange)
        return () => {
            checkbox.removeEventListener('change', handleChange)
        }
    }, [])

    const handleOpenTopUpForm = () => {
        handleStepChange(2)
    }

    const handleOpenTopUpFormKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        event.preventDefault()
        handleOpenTopUpForm()
    }

    return (
        <Modal
            id={INSUFFICIENT_BALANCE_MODAL_ID}
            className={cn('modal-priority', { 'full-width': step === 2 })}
            aria-label='Недостаточно средств'
        >
            <div className='flex flex-col gap-6 w-full'>
                {step === 1 && (
                    <>
                        <h3 className='text-2xl font-medium text-white'>Недостаточно токенов</h3>
                        <p className='text-base text-[#aba7af] leading-[1.4]'>
                            Для этого действия не хватает токенов. Вы можете докупить их пакетами или{' '}
                            <button
                                type='button'
                                className='text-[#9161ed] underline hover:text-[#be96ff] transition-colors'
                                onClick={handleOpenTopUpForm}
                                onKeyDown={handleOpenTopUpFormKeyDown}
                                tabIndex={0}
                                aria-label='Оформить подписку'
                            >
                                оформить подписку
                            </button>
                            :
                        </p>
                        <div className='flex flex-col gap-2 w-full'>
                            <Button size='lg' emphasis='accent' className='w-full' onClick={handleOpenTopUpForm}>
                                Докупить
                            </Button>
                            <Button
                                size='lg'
                                emphasis='accent'
                                variant='ghost'
                                className='w-full'
                                onClick={handleClose}
                            >
                                Отмена
                            </Button>
                        </div>
                    </>
                )}

                {step === 2 && (
                    <>
                        <h3 className='text-2xl font-medium text-white'>Подписка/Разовая покупка токенов</h3>
                        <TopUpForm onCancel={handleClose} onSuccess={handleClose} />
                    </>
                )}
            </div>
        </Modal>
    )
}
